import { createSupplyPDFDocument } from './createSupplyPdfDocument'

export async function createSupplyPDF(supplyForms, deliveryDate, supplyDivisionId, supplier,printSetting) {

  return await createSupplyPDFDocument(
    supplyForms,
    deliveryDate,
    supplyDivisionId,
    supplier,
    printSetting
  );
}

